import { render, staticRenderFns } from "./partnerWhiteList.vue?vue&type=template&id=5a99ac04&"
import script from "./partnerWhiteList.vue?vue&type=script&lang=js&"
export * from "./partnerWhiteList.vue?vue&type=script&lang=js&"
import style0 from "./partnerWhiteList.vue?vue&type=style&index=0&id=5a99ac04&prod&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports